import NewQuickPurchaseContainer from './NewQuickPurchaseContainer';

export default NewQuickPurchaseContainer;
